import { FlexBox } from '@fable/components'
import { MomBooksGridY } from './MomBooksGridY'
import { MomBooksGridMain } from './MomBooksGridMain'
import { MomBooksGridX } from './MomBooksGridX'
import { css } from '@fable/theme'

interface Props {
  animate?: boolean
}

export const MomBooksGrid = ({ animate = true }: Props) => (
  <FlexBox
    className={css`
      margin-top: 20px;
      gap: 2px;
    `}
    alignItems="stretch"
  >
    <MomBooksGridY />
    <FlexBox
      className={css`
        width: 100%;
      `}
      flexDirection="column"
    >
      <MomBooksGridMain animate={animate} />
      <MomBooksGridX />
    </FlexBox>
  </FlexBox>
)
